export const GET_POLICY_PDF_START = 'GET_POLICY_PDF_START';
export const GET_POLICY_PDF_SUCCESS = 'GET_POLICY_PDF_SUCCESS';
export const GET_POLICY_PDF_FAILED = 'GET_POLICY_PDF_FAILED';

export interface PolicyGetPdfStore {
  loading?: boolean;
  error?: unknown;
  result?: Record<string, Blob>;
  reqPolicyNumber?: string;
  lang?: string;
}
